import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Home } from 'config/images'

export const HeaderContainer = styled.div`
	background-color: ${(props) => props.theme.black};
	padding: 100px 0px 60px 0px;
	background-image: url(${Home.headerBackground});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	@media (max-width: 800px) {
		padding: 80px 0px 60px 0px;
	}
	@media (max-width: 650px) {
		padding: 60px 0px;
	}
`
export const HeaderContent = styled.div`
	max-width: 1400px;
	padding: 0px 50px;
	margin: 0px auto;
	display: flex;
	align-items: flex-end;

	@media (max-width: 800px) {
		flex-wrap: wrap;
		padding: 0px 40px;
	}
	@media (max-width: 650px) {
		padding: 0px 30px;
	}
	@media (max-width: 450px) {
		padding: 0px 20px;
	}
`
export const HeaderLeftColumn = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-content: flex-end;
	width: 40%;
	padding-top: 100px;
	padding-right: 1%;

	@media (max-width: 1000px) {
		width: 50%;
	}
	@media (max-width: 800px) {
		padding-right: 0px;
		width: 100%;
		max-width: 500px;
		margin: 0px auto;
	}
`
export const HeaderTitle = styled.h1`
	color: ${(props) => props.theme.white};
	font-size: 28px;
	margin-top: 0px;
	margin-bottom: 50px;
	line-height: 1.25;

	@media (max-width: 1200px) {
		font-size: 24px;
		margin-bottom: 40px;
	}
	@media (max-width: 1000px) {
		font-size: 22px;
		margin-bottom: 30px;
	}
	@media (max-width: 800px) {
		font-size: 21px;
	}
	@media (max-width: 650px) {
		font-size: 20px;
	}
	@media (max-width: 450px) {
		font-size: 18px;
	}
`
export const HeaderCopy = styled.p`
	color: ${(props) => props.theme.white};
	font-size: 18px;
	margin-top: 0px;
	margin-bottom: 50px;
	line-height: 1.5;

	@media (max-width: 1200px) {
		font-size: 17px;
		margin-bottom: 40px;
	}
	@media (max-width: 1000px) {
		font-size: 16px;
		margin-bottom: 30px;
	}
	@media (max-width: 650px) {
		font-size: 15px;
	}
	@media (max-width: 450px) {
		font-size: 14px;
	}
`
export const HeaderLink = styled(Link)`
	text-decoration: none;
	color: ${(props) => props.theme.white};
	text-align: center;
	display: inline-block;
	border: 2px solid ${(props) => props.theme.white};
	padding: 15px 50px;
	width: auto;

	/* Right now we don't have a resason for this button */
	display: none;
`
export const HeaderRightColumn = styled.div`
	padding-left: 2%;
	width: 60%;

	@media (max-width: 1000px) {
		width: 50%;
	}
	@media (max-width: 800px) {
		padding-left: 0px;
		width: 100%;
		max-width: 600px;
		margin: 0px auto;
	}
`
export const HeaderImage = styled.img`
	display: block;
	width: 100%;
`

export const BodyContainer = styled.div`
	padding-top: 30px;
`
export const BodyContent = styled.div`
	margin: 0px auto;
	max-width: 1400px;
	padding: 0px 50px;
`
export const BodyRow = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 35px 0px;

	@media (max-width: 800px) {
		flex-wrap: wrap;
	}
`
export const BodyRowLeftColumn = styled.div`
	width: 40%;
	padding-right: 1%;

	@media (max-width: 1000px) {
		width: 50%;
	}
	@media (max-width: 800px) {
		padding-right: 0px;
		width: 100%;
		max-width: 600px;
		margin: 0px auto;
		margin-bottom: 30px;
	}
`
export const BodyRowImageSmall = styled.img`
	display: block;
	width: 100%;
	padding: 0px 12%;

	@media (max-width: 1000px) {
		padding: 0px 8%;
	}
`
export const BodyRowImage = styled.img`
	display: block;
	width: 100%;
`
export const BodyRowRightColumn = styled.div`
	padding-left: 2%;
	width: 60%;

	@media (max-width: 1000px) {
		width: 50%;
	}
	@media (max-width: 800px) {
		padding-left: 0px;
		width: 100%;
		max-width: 500px;
		margin: 0px auto;
	}
`
export const BodyRowTitle = styled.h2`
	margin-top: 0px;
	margin-bottom: 50px;
	color: ${(props) => props.theme.black};
	font-size: 26px;
	line-height: 1.25;
	display: block;

	@media (max-width: 1200px) {
		font-size: 24px;
		margin-bottom: 40px;
	}
	@media (max-width: 1000px) {
		font-size: 22px;
		margin-bottom: 30px;
	}
	@media (max-width: 800px) {
		font-size: 21px;
	}
	@media (max-width: 650px) {
		font-size: 20px;
	}
	@media (max-width: 450px) {
		font-size: 18px;
	}
`
export const BodyRowCopy = styled.p`
	margin-top: 0px;
	margin-bottom: 50px;
	color: ${(props) => props.theme.black};
	font-size: 18px;
	line-height: 1.5;
	display: block;

	@media (max-width: 1200px) {
		font-size: 17px;
		margin-bottom: 40px;
	}
	@media (max-width: 1000px) {
		font-size: 16px;
		margin-bottom: 30px;
	}
	@media (max-width: 650px) {
		font-size: 15px;
	}
	@media (max-width: 450px) {
		font-size: 14px;
	}
`
export const BodyRowLink = styled(Link)`
	text-decoration: none;
	color: ${(props) => props.theme.black};
	text-align: center;
	display: inline-block;
	border: 2px solid ${(props) => props.theme.black};
	padding: 15px 50px;
	width: auto;

	/* Right now we don't have a resason for this button */
	display: none;
`

export const BodyVideoWrapper = styled.div`
	max-width: 850px;
	padding-left: 50px;
	padding-right: 50px;
	padding-bottom: 50px;
	margin-right: auto;
	margin-left: auto;

	@media (max-width: 800px) {
		width: 100%;
		padding: 0px;
	}
`
export const BodyVideo = styled.video`
	width: 100%;
	display: block;
`

export const TrustedContainer = styled.div`
	padding: 50px 0px;
	background-color: ${(props) => props.theme.lightGray};
`
export const TrustedContent = styled.div`
	max-width: 1400px;
	padding: 0px 50px;
	margin: 0px auto;
`
export const TrustedTitle = styled.h2`
	font-size: 3.5vw;
	color: ${(props) => props.theme.black};
	margin-top: 0px;
	margin-bottom: 50px;
	text-align: center;
	display: block;
	line-height: 1;

	@media (max-width: 1200px) {
		margin-bottom: 40px;
	}
	@media (max-width: 1000px) {
		margin-bottom: 30px;
	}
	@media (max-width: 800px) {
		font-size: 30px;
		line-height: 1.25;
	}
	@media (max-width: 650px) {
		font-size: 28px;
	}
	@media (max-width: 450px) {
		font-size: 26px;
	}
`
export const TrustedLogoRow = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
`
export const TrustedLogoTall = styled.img`
	height: 110px;
	display: block;
	margin: 20px;

	@media (max-width: 800px) {
		height: 90px;
		margin: 15px;
	}
	@media (max-width: 450px) {
		height: auto;
		width: 100%;
		max-width: 150px;
		margin: 0px auto 15px auto;
	}
`
export const TrustedLogo = styled.img`
	height: 55px;
	display: block;
	margin: 20px;

	@media (max-width: 800px) {
		height: 45px;
		margin: 15px;
	}
	@media (max-width: 450px) {
		height: auto;
		width: 100%;
		max-width: 150px;
		margin: 0px auto 15px auto;
	}
`

export const DigitizeContainer = styled.div`
	background-color: ${(props) => props.theme.black};
	padding: 80px 0px;
	background-image: url(${Home.headerBackground});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	@media (max-width: 800px) {
		padding: 60px 0px;
	}
	@media (max-width: 650px) {
		padding: 50px 0px;
	}
	@media (max-width: 450px) {
		padding: 40px 0px;
	}
`
export const DigitizeContent = styled.div`
	max-width: 1400px;
	padding: 0px 50px;
	margin: 0px auto;
	display: flex;
	align-items: flex-end;

	@media (max-width: 800px) {
		flex-wrap: wrap;
		padding: 0px 40px;
	}
	@media (max-width: 650px) {
		padding: 0px 30px;
	}
	@media (max-width: 450px) {
		padding: 0px 20px;
	}
`
export const DigitizeLeftColumn = styled.div`
	width: 50%;

	@media (max-width: 800px) {
		width: 100%;
		max-width: 450px;
		margin: 0px auto;
	}
`
export const DigitizeTitle = styled.h2`
	color: ${(props) => props.theme.white};
	font-size: 30px;
	margin-top: 0px;
	margin-bottom: 60px;
	line-height: 1.25;

	@media (max-width: 1200px) {
		font-size: 28px;
		margin-bottom: 40px;
	}
	@media (max-width: 1000px) {
		font-size: 26px;
		margin-bottom: 30px;
	}
	@media (max-width: 800px) {
		font-size: 24px;
	}
	@media (max-width: 650px) {
		font-size: 22px;
	}
	@media (max-width: 450px) {
		font-size: 20px;
	}
`
export const DigitizeCopy = styled.p`
	margin-top: 0px;
	margin-bottom: 50px;
	color: ${(props) => props.theme.white};
	font-size: 18px;
	line-height: 1.5;
	display: block;
	padding-right: 35%;

	@media (max-width: 1200px) {
		margin-bottom: 40px;
		font-size: 17px;
		padding-right: 25%;
	}
	@media (max-width: 1000px) {
		margin-bottom: 30px;
		font-size: 16px;
		padding-right: 15%;
	}
	@media (max-width: 800px) {
		padding-right: 0px;
	}
	@media (max-width: 650px) {
		font-size: 15px;
	}
	@media (max-width: 450px) {
		font-size: 14px;
	}
`
export const DigitizeList = styled.ul`
	padding: 0px;
	margin: 0px;
	list-style: none;
`
export const DigitizeListItem = styled.li`
	color: ${(props) => props.theme.white};
	font-size: 16px;
	line-height: 1.5;
	display: flex;
	align-items: center;
	margin-bottom: 15px;
	font-style: italic;
	letter-spacing: 3px;

	&::before {
		content: '';
		display: inline-block;
		width: 8px;
		height: 8px;
		background-color: ${(props) => props.theme.white};
		margin-right: 20px;
	}

	@media (max-width: 1200px) {
		font-size: 15px;
	}
	@media (max-width: 1000px) {
		font-size: 14px;
	}
	@media (max-width: 650px) {
	}
	@media (max-width: 450px) {
	}
`
export const DigitizeRightColumn = styled.div`
	width: 50%;

	@media (max-width: 800px) {
		width: 100%;
		padding-top: 50px;
	}
`
export const DigitizeImage = styled.img`
	display: block;
	width: 140%;
	margin-left: -40%;

	@media (max-width: 1200px) {
		width: 130%;
		margin-left: -30%;
	}
	@media (max-width: 1000px) {
		width: 125%;
		margin-left: -25%;
	}
	@media (max-width: 800px) {
		width: 100%;
		max-width: 600px;
		margin: 0px auto;
	}
`
